<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    this.$toast.setDefaultOptions({
      duration: 1500
    })
  }
}
</script>
<style lang="scss">
#app {
  min-height: 100vh;
  background: #f8f8f8;
}
.van-tabbar--fixed {
  z-index: 100 !important;
}
</style>
